// ============================================================================
// SUFFIX AUTOMATON - ALGORITHM METADATA
// ============================================================================

export const meta = {
  id: 'suffix-automaton',
  name: 'Suffix Automaton',
  category: 'Strings',
  complexity: {
    time: 'O(N)',
    space: 'O(2N)'
  },
  description: 'A minimal deterministic finite automaton that recognizes all substrings of a given string. It can be built in linear time and enables efficient substring operations and pattern matching.'
};
